module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCountry),
      expression: "selectedCountry"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onCountryChange()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.countries), function(cName, cCode) {
    return _c('option', {
      domProps: {
        "value": cCode
      }
    }, [_vm._v(_vm._s(cName))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e94b6cf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/country-selector.vue
// module id = 6El/
// module chunks = 1